export default {"src":"/polygon/_next/static/media/book-dark.bbd4de3a.svg","height":24,"width":24};